import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { LegalLang } from '../../shared/legal-lang-toggle/legal-lang-toggle.component';
import { environment } from '../../../environments/environment';

/**
 * Public applications page served at '/products'.
 *
 * This is the URL submitted as the application home page on the Google OAuth consent
 * screen: it describes both applications and states, scope by scope, what Google data
 * they request and why. Like '/' it must stay unguarded and render for an anonymous
 * visitor — the verification reviewer never signs in.
 */
@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.scss'],
    standalone: false
})
export class ProductsComponent implements OnInit {

  // Local to this page — see LegalLangToggleComponent for why the app's LangService
  // is not used here.
  lang: LegalLang = 'en';

  constructor(private titleService: Title, private route: ActivatedRoute) { }

  ngOnInit() {
    // No 'background' body class: this page sits on surface-page like the landing
    // page, not on the grey sunken surface used by the document pages.
    if (this.route.snapshot.queryParamMap.get('lang') === 'fr') {
      this.lang = 'fr';
    }
    this.setTitle();
  }

  onLangChange(lang: LegalLang) {
    this.lang = lang;
  }

  // 'Applications' is spelled the same in both languages, so unlike the legal pages
  // the title does not need to follow the toggle.
  private setTitle() {
    this.titleService.setTitle(`Applications | ${environment.appName}`);
  }

}
